<template>
  <div class="page-container">
    <div v-if="productList.length>0">
      <ProList key="p1" :page="true" :list="productList" @nextPageTarget="getSearchAll()" :isend="isend"></ProList>
    </div>
    <div v-else-if="artistList.length>0">
      <Artist :list="artistList" key="p2"></Artist>
      <el-link class="btn-more" :underline="false" disabled v-if="isend">暂无结果</el-link>
      <el-link class="btn-more" :underline="false" @click="getSearchAll()" v-if="!isend">加载更多</el-link>
    </div>
    <div class="section" v-else-if="openPageList.length>0">
      <div class="new-list">
        <div class="news-item new-item-lg" v-for="(item,index) in openPageList" :key="index">
          <div class="news-item-link">
            <el-row class="row">
              <el-col :span="8">
                <div class="picture">
                  <div class="img" :style="'background-image:url('+ item.faceimage+')'"></div>
                </div>
              </el-col>
              <el-col :span="16">
                <div class="info">
                  <router-link :to="{path:'/news/detail',query:{id:item.id}}" class="title">{{item.title}}</router-link>
                  <div class="dec">{{item.content}}</div>
                  <div class="date">发布时间：{{item.createtime}}</div>
                  <div class="info-tools">
                    <router-link :to="{path:'/news/detail',query:{id:item.id}}" class="more">查看详情》</router-link>
                    <span class="comment"><span class="comment-item"><i>{{item.userLikeCount ||  0}}</i></span><span class="comment-item"><i>{{item.readcount ||  0}}</i></span></span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <el-link class="btn-more" :underline="false" disabled v-if="isend">暂无结果</el-link>
      <el-link class="btn-more" :underline="false" @click="getSearchAll()" v-if="!isend">加载更多</el-link>
    </div>
    <div v-if="productList.length===0 && artistList.length===0 && openPageList.length===0">
      <el-link class="btn-more" :underline="false" disabled v-if="isend">暂无结果</el-link>
    </div>
  </div>
</template>
<script>
import { Common } from '../../model/common';
import ProList from '../../components/prolist.vue';
import Artist from '../../components/artist.vue';
let common = new Common();
export default {
  name: 'index',
  data() {
    return {
      keyword: decodeURIComponent(this.$route.query.keyword),
      type: this.$route.query.type,
      pageSize: 12,
      pageIndex: 1,
      isend: false,
      artistList: [],
      openPageList: [],
      productList: []
    }
  },
  components: {
    ProList,
    Artist
  },
  created() {
    this.$emit('searchTarget', { keyword: this.keyword, type: this.type ? this.type.toString() : "" })
    this.getSearchAll()
  },
  methods: {
    getSearchAll(done) {
      let _this = this;
      if (done) {//如果是直接按搜索 所有数据得重置
        _this.productList = [];
        _this.artistList = [];
        _this.openPageList = [];
        _this.pageIndex = 1;
        _this.pageSize = 12;
        _this.isend = false;
      }
      common.searchAll({
        Name: _this.keyword,
        ID: _this.user ? _this.user.id : "",
        SearchType: _this.type,
        PageIndex: _this.pageIndex,
        PageSize: _this.pageSize,
        Type: 1
      }).then(function (res) {
        let plist = [];
        if (res.ArtistList && res.ArtistList.length > 0) {
          plist = res.ArtistList;
        } else if (res.OpenPageList && res.OpenPageList.length > 0) {
          plist = res.OpenPageList;
        } else if (res.ProductList && res.ProductList.length > 0) {
          plist = res.ProductList;
        }
        if (plist.length < _this.pageSize || plist.length == 0) {
          _this.isend = true
        }
        if (res.ArtistList && res.ArtistList.length > 0) {
          _this.artistList = plist.length > 0 ? _this.artistList.concat(plist) : _this.artistList;
          _this.pageIndex++;
        } else if (res.OpenPageList && res.OpenPageList.length > 0) {
          _this.openPageList = plist.length > 0 ? _this.openPageList.concat(plist) : _this.openPageList;
          _this.pageIndex++;
        } else if (res.ProductList && res.ProductList.length > 0) {
          _this.productList = plist.length > 0 ? _this.productList.concat(plist) : _this.productList;
          _this.pageIndex++;
        }
      })
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (to.query == from.query) {
      next()
    } else {
      next();
      this.keyword = decodeURIComponent(to.query.keyword);
      this.type = to.query.type;
      this.getSearchAll(true)
    }
  },
  watch: {
    // 'productList': {
    //   handler: function (newval) {
    //     let _this = this;
    //     console.log(newval)
    //     _this.newPorductList = newval
    //   },
    //   deep: true
    // }
  }
}
</script>